import componentInit from 'components/componentInit'
import $ from 'jQuery'

let mod = {}

mod.initComponents = function(parentElement)
{
  // Decrypt encrypted elements.
  let encryptedElements = $(parentElement).find('.encrypted').get()
  for(let element of encryptedElements)
  {
    // If this element is a element decrypt href attribute.
    if(element.tagName.toLowerCase() === 'a')
    {
      let href = $(element).attr('href')
      if(href)
        $(element).attr('href', mod.b64DecodeUnicode(href))

      let title = $(element).attr('title')
      if(title)
        $(element).attr('title', mod.b64DecodeUnicode(title))

      let spanElements = $(element).children('span').get()
      for(let span of spanElements)
      {
        let html = $(span).html()
        if(html)
          $(span).html(mod.b64DecodeUnicode(html))
      }
    }

    // Else decrypt element content.
    else
    {
      let html = $(element).html()
      if(html)
        $(element).html(mod.b64DecodeUnicode(html))
    }

    // Remove class to avoid multiple decryptions.
    $(element).removeClass('encrypted')

    // Show element.
    $(element).show()
  }
}

// atob() does not decode UTF-8 string correctly. Use the solution described at
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_1_%E2%80%93_escaping_the_string_before_encoding_it
mod.b64DecodeUnicode = function(str)
{
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function(c)
  {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  mod.initComponents(parentElement)
}

export default mod



// WEBPACK FOOTER //
// ./vendor/kuvio/kustaa/applications/publicFrontend/scripts/components/encrypted.js